import { FC, useState } from 'react';
import { characters, Character } from '../../data/characters';

interface CharacterSelectionProps {
  onSelect: (character: Character) => void;
}

const CharacterSelection: FC<CharacterSelectionProps> = ({ onSelect }) => {
  const [selectedCharacter, setSelectedCharacter] = useState<Character | null>(null);

  // Guard against empty characters array
  if (!characters || characters.length === 0) {
    return (
      <div className="text-center p-8">
        <p className="text-gray-400">No characters available</p>
      </div>
    );
  }

  const handleCharacterSelect = (character: Character) => {
    setSelectedCharacter(character);
  };

  const handleStartBattle = () => {
    if (selectedCharacter) {
      onSelect(selectedCharacter);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">Select Your Character</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {characters.map((character) => (
          <div
            key={character.id}
            onClick={() => handleCharacterSelect(character)}
            className={`bg-[#2A3644] rounded-lg p-4 cursor-pointer transition-all transform hover:scale-102 ${
              selectedCharacter?.id === character.id
                ? 'ring-2 ring-orange-500 scale-105'
                : 'hover:bg-[#3A4654]'
            }`}
          >
            <div className="aspect-square w-full rounded-lg overflow-hidden mb-4">
              <img
                src={character.imageUrl}
                alt={character.name}
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-lg font-semibold mb-2">{character.name}</h3>
            <div className="space-y-2">
              <div className="flex justify-between text-sm">
                <span>Health:</span>
                <span>{character.baseStats.health}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span>Energy:</span>
                <span>{character.baseStats.energy}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedCharacter && (
        <div className="mt-8 flex justify-center">
          <button
            onClick={handleStartBattle}
            className="button-gaming px-8 py-3 text-lg"
          >
            Start Battle with {selectedCharacter.name}
          </button>
        </div>
      )}
    </div>
  );
};

export default CharacterSelection; 